import React from 'react';
import cn from 'classnames';
import InfoRow from '../InfoRow/InfoRow';
import RoundIconBackground from '../RoundIconBackground/RoundIconBackground';
import { callInfoAdapter } from '../../utils/callInfoAdapter';
import Wrapper from '../Wrapper/Wrapper';
import styles from './InfoTablo.module.scss';

const InfoTablo = ({
  items,
  list = true,
  className,
  insert = false,
  iconPos,
  onRowClick,
}) => {
  return (
    <Wrapper
      el={list ? 'ul' : 'div'}
      className={cn(styles.root, className, {
        [styles.insert]: insert,
        [styles.list]: list,
      })}
    >
      {items.map((item) => (
        <InfoRow
          listItem
          key={item.id || item.uniqueId}
          item={callInfoAdapter(item)}
          iconPos={iconPos}
          onRowClick={onRowClick}
          renderBadge={({ className }) => (
            <RoundIconBackground
              className={className}
              size="small"
              containerType={item.iconType}
              renderIcon={item.renderIcon}
            />
          )}
        />
      ))}
    </Wrapper>
  );
};

export default InfoTablo;
